import React from 'react';
import {Grid} from 'semantic-ui-react';

import {ChatedHeader} from '../components/chated-header';
import {ChatedDrawer} from '../components/chated-drawer';
import './index.css';

export class NavigationLayout extends React.Component {
	componentWillMount() {
	}

	getLocation() {
		return this.props.children.props.location;
	}

	getContainerClass() {
		const {containerClass} = this.props;
		if (this.props.narrow) {
			return `${containerClass} narrow`;
		}
		if (this.props.center) {
			return `${containerClass} center`;
		}
		return containerClass || '';
	}

	render() {
		const location = this.getLocation();
		const containerClass = this.getContainerClass();

		return (
			<Grid centered>
				<Grid.Row className='topmost'>
					<Grid.Column>
						<ChatedHeader compact />
					</Grid.Column>
				</Grid.Row>

				<Grid.Row>
					<Grid.Column className='bg-light-grey'>
						<div>
							<ChatedDrawer location={location} />
						</div>
						<div className={containerClass}>
							{ this.props.children }
						</div>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		);
	}
}

export default NavigationLayout;



// WEBPACK FOOTER //
// ./src/layouts/navigation-layout.jsx